// extracted by mini-css-extract-plugin
export var arrow = "key-figure-row-v2-module--arrow--6cf89";
export var carouselButtons = "key-figure-row-v2-module--carouselButtons--cad14";
export var container = "key-figure-row-v2-module--container--24af5";
export var nextButton = "key-figure-row-v2-module--nextButton--e9c2c";
export var prevButton = "key-figure-row-v2-module--prevButton--3ec1f";
export var transformContainer = "key-figure-row-v2-module--transformContainer--adb86";